import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import './style.scss'

export default function EventCostModal({
  isOpen: isOpenProp,
  onClose: onCloseProp,
  modal,
  onSave,
  initialCost = 0,
}) {
  const isOpen = modal ? modal.isOpen : isOpenProp
  const onClose = modal ? modal.closeModal : onCloseProp

  const [costInput, setCostInput] = useState(
    initialCost > 0 ? String(initialCost) : ''
  )

  useEffect(() => {
    if (isOpen) {
      setCostInput(initialCost > 0 ? String(initialCost) : '')
    }
  }, [isOpen, initialCost])

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose?.()
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, onClose])

  if (!isOpen) return null

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose?.()
    }
  }

  const handleSave = () => {
    const numericCost = parseFloat(costInput) || 0
    onSave?.(numericCost)
    onClose?.()
  }

  return (
    <div
      className="modal-backdrop open"
      id="event-cost-modal"
      onClick={handleBackdropClick}
    >
      <div className="modal sm" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">Event Cost</span>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <div className="modal-body">
          <p style={{ marginBottom: '12px' }}>
            Enter what this event cost you (wholesale goods, delivery, packaging,
            etc.) so Total Profit can be calculated.
          </p>
          <label
            style={{
              display: 'block',
              fontSize: '11px',
              fontWeight: 600,
              color: 'var(--mid, #888780)',
              marginBottom: '6px',
            }}
            htmlFor="event-cost-input"
          >
            Event Cost ($)
          </label>
          <input
            type="number"
            id="event-cost-input"
            className="input"
            style={{ width: '100%' }}
            placeholder="0.00"
            step="0.01"
            min="0"
            value={costInput}
            onChange={(e) => setCostInput(e.target.value)}
          />
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn teal-outline"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  )
}

EventCostModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  modal: PropTypes.shape({
    isOpen: PropTypes.bool,
    openModal: PropTypes.func,
    closeModal: PropTypes.func,
    toggleModal: PropTypes.func,
  }),
  onSave: PropTypes.func,
  initialCost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
